import { useRuleDetailDialogControls } from '../../hooks/useRuleDetailDialogControls/useRuleDetailDialogControls';
import { RuleDetailDialog } from '../RuleDetailDialog/RuleDetailDialog';
import { PageLayout } from '~/components/PageLayout/PageLayout';

export const RuleDetailCreate = () => {
  const { closeDialog } = useRuleDetailDialogControls();

  return (
    <>
      <PageLayout fullHeight>
        <RuleDetailDialog closeDialog={closeDialog} isOpen={true} />
      </PageLayout>
    </>
  );
};
